import { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { LoadingPage } from '../../pages/LoadingPage';

const PhoneVerificationFlowLazy = lazy(() =>
  import('./phone-verification-flow/PhoneVerificationFlow').then((module) => ({
    default: module.PhoneVerificationFlow,
  })),
);
const ContextSettingLazy = lazy(() =>
  import('./phone-verification-flow/steps/ContextSetting').then((module) => ({
    default: module.ContextSetting,
  })),
);
const SendCodeLazy = lazy(() =>
  import('./phone-verification-flow/steps/SendCode').then((module) => ({
    default: module.SendCode,
  })),
);
const VerifyCodeLazy = lazy(() =>
  import('./phone-verification-flow/steps/VerifyCode').then((module) => ({
    default: module.VerifyCode,
  })),
);

type PhoneVerificationProps = {
  supportLink: string;
  phoneNumber: string;
  voicemailConsent: boolean;
  onComplete?: () => void;
};

const PhoneVerification = ({
  supportLink,
  phoneNumber,
  voicemailConsent,
  onComplete,
}: PhoneVerificationProps) => {
  const { t } = useTranslation('phone-verification');

  return (
    <>
      <Helmet title={t('DocumentTitle')} />
      <div className="container mx-auto max-w-512 pb-xl">
        <Suspense fallback={<LoadingPage />}>
          <PhoneVerificationFlowLazy
            supportLink={supportLink}
            phoneNumber={phoneNumber}
            voicemailConsent={voicemailConsent}
            onComplete={onComplete}
            availableSteps={[
              { id: 'contextSetting', component: ContextSettingLazy },
              { id: 'sendCode', component: SendCodeLazy },
              { id: 'verifyCode', component: VerifyCodeLazy },
            ]}
          />
        </Suspense>
      </div>
    </>
  );
};

export default PhoneVerification;
